"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressToHex = exports.bufferToHex = exports.utf8ToHex = exports.bigIntToHex = exports.bigIntToBuffer = exports.bufferToBigInt = exports.stringToBuffer = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const address_1 = require("../address");
const contractsCodecUtils = __importStar(require("../smartcontracts/codec/utils"));
const codecUtils = __importStar(require("../utils.codec"));
function stringToBuffer(value) {
    return Buffer.from(value);
}
exports.stringToBuffer = stringToBuffer;
function bufferToBigInt(buffer) {
    if (buffer.length == 0) {
        return new bignumber_js_1.default(0);
    }
    return contractsCodecUtils.bufferToBigInt(buffer);
}
exports.bufferToBigInt = bufferToBigInt;
function bigIntToBuffer(value) {
    if (value == 0) {
        return Buffer.from([]);
    }
    return contractsCodecUtils.bigIntToBuffer(value);
}
exports.bigIntToBuffer = bigIntToBuffer;
function bigIntToHex(value) {
    if (value == 0) {
        return "";
    }
    return contractsCodecUtils.getHexMagnitudeOfBigInt(value);
}
exports.bigIntToHex = bigIntToHex;
function utf8ToHex(value) {
    const hex = Buffer.from(value).toString("hex");
    return codecUtils.zeroPadStringIfOddLength(hex);
}
exports.utf8ToHex = utf8ToHex;
function bufferToHex(value) {
    const hex = value.toString("hex");
    return codecUtils.zeroPadStringIfOddLength(hex);
}
exports.bufferToHex = bufferToHex;
function addressToHex(address) {
    const buffer = address_1.Address.fromBech32(address.toString()).pubkey();
    return buffer.toString("hex");
}
exports.addressToHex = addressToHex;
